var element =  document.getElementsByClassName('b2b-logo-empresas-3');
if (element.length > 0) {
    
    const carouselId = document.querySelector(".carousel-inner").children[0];
    carouselId.classList.add("active");

    var carouselIndicators = document.querySelector(".carousel-indicators").children[0];
    carouselIndicators.classList.add("active");

}